// extracted by mini-css-extract-plugin
module.exports = {"tagMain":"tagMain--1MODA","orange":"orange--3crEt","blue":"blue--1vhFJ","red":"red--2KqxU","green":"green--1Wzoz","radius":"radius---rMjc"};